import { useUserOrganization } from '@modules-deprecated/app/organization'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'
import { UiSetup } from '@modules-deprecated/app/organization/enums/uiSetup'

import { CountryIsoCode } from '../../types/countryIsoCode'

interface SplitTestCriteria {
  buckets?: number[]
  countries?: Uppercase<CountryIsoCode>[]
  isTrial?: boolean
  plans?: SubscriptionPlan[]
  uiSetups?: UiSetup[]
}

interface UseSplitTestResult {
  isEnabled: boolean
  isLoading: boolean
}

export const useSplitTest = (criteria?: SplitTestCriteria): UseSplitTestResult => {
  const { organization, isLoading } = useUserOrganization()

  if (isLoading || !organization) {
    return { isLoading: true, isEnabled: false }
  }

  const { buckets, countries, isTrial, plans, uiSetups } = criteria || {}

  const matchesBuckets = !buckets || buckets.includes(organization.randomBucket)
  const matchesCountries = !countries || countries.includes(organization.countryId)
  const matchesIsTrial = isTrial === undefined || organization.isTrial === isTrial
  const matchesPlans = !plans || plans.includes(organization.subscriptionPlan)
  const matchesUiSetups = !uiSetups || uiSetups.includes(organization.uiSetup)

  return {
    isLoading: false,
    isEnabled: matchesBuckets && matchesCountries && matchesIsTrial && matchesPlans && matchesUiSetups,
  }
}
